/**
 * List of states for a valuation
 */
 export enum ValuationState {
    Requested = 'Requested',
    Submitted = 'Submitted'
}